// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tip-text[data-v-7cc1a371] {\r\n  color: #909399;\r\n  font-size: 12px;\n}\n.ml10[data-v-7cc1a371] {\r\n  margin-left: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
